import Vue from 'vue';
import Router from 'vue-router';
import routerMap from "./router";
import * as storage from "utils/sessionStorage";
import store from "../store";
import whiteList from "./whitelist"; // 登白名单

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

const LOGIN_KEY = 'setLogin';
let isLogin = storage.getCookie(LOGIN_KEY) === 'true';

const router = new Router({
  mode: 'history', //后端支持可开
  routes: routerMap,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
});
// 路由相关钩子
router.beforeEach((to, from, next) => {
  // console.log(to,from)
  if (isLogin === true) { // 判断是否登录
    if (to.name === 'login') {
      next({
        path: '/'
      });
    } else {
      if (!store.getters.user.userId) {
        // 刷新如果得不到基础信息，重新拿一次
        store.dispatch('getInfo').then(() => {
          console.log("进入getInfo")
          next();
        })
      } else {
        next();
      }
    }
  } else if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
    // if (to.name === 'login') {
    //   next();
    // } else{
    next();
    // }

  } else {
    if (storage.getCookie('SET_USER_TYPE')) {
      store.dispatch('logout', )
    } else {
      if (storage.getData('loginType') && storage.getData('loginType') === 'merchant') {
        next({
          path: 'login1'
        })
      } else {
        next({
          path: '/login'
        });
      }
    }
    // store.dispatch('logout',)
    // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
  }
});

router.afterEach((route) => {
  window.scrollTo(0, 0); //跳转另一页面是回到顶部
});


export function setLogin(flag, expiresDay) {
  isLogin = flag;
  flag ? storage.setCookie(LOGIN_KEY, flag, {
    expires: expiresDay
  }) : storage.setCookie(LOGIN_KEY, flag);
}

export default router;